import { http } from '../axios';
import { shopPrefix } from '../../config';
import { Pagination } from '../../../models/Pagination';
import { ListProduct } from '../../../models/Product';
import * as types from '../../store/constants';
import { ProductFilter } from '../../store/api';

const url = `${shopPrefix}/v1/shoppingcart/products`;

interface ShoppingCartParams {
    pagination: Pagination;
    filterMap: ProductFilter;
    groupType: string | null;
    groupId: string | null | undefined;
}

interface CartProductsResponse {
    hits?: ListProduct[];
    totalHits: number;
}
export const fetchShoppingCartProducts = ({ filterMap, pagination, groupId, groupType }: ShoppingCartParams) => {
    return http
        .post<CartProductsResponse>(url, filterMap, {
            params: {
                ...pagination,
                groupType: groupType !== types.GROUPBY_PRODUCTS ? groupType : null,
                groupId
            }
        })
        .then(response => response.data);
};
